export default function () {
  const widgetName = 'xmasDonate';
  const widgetOpts = xmasDonateOpts;

  function validateId(data) {
    if (data.items.length < 1) {
      $(`#${widgetName}`).remove();
    }

  }

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW',
    },
    cardWidgetLoaded: function (data) {
      validateId(data);
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    link: ['all'], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: {
      visible: false,
      text: 'MORE',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: true,
  });
}
